import s1 from "../assets/images/services1.png";
import website from "../assets/images/website.svg";
import websitedesign from "../assets/images/websitedesign.svg";
import video from "../assets/images/video.svg";
import eccomerce from "../assets/images/eccomerce.svg";
import seo from "../assets/images/seo.svg";
// import s1 from "../assets/images/services1.png";
var ServiceData = [
	{
		"name":"Website Design",
		"content":"Attract your audience.",
		"images":website
	},
	{
		"name":"Ecommerce Development",
		"content":"Sell your best product",
		"images":eccomerce
	}
	,
	{
		"name":"Custom Website",
		"content":"Get you Fully Customize",
		"images":websitedesign
	}
	
	,
	{
		"name":"SEO",
		"content":"Get's Your first position",
		"images":seo
	}
	
	,
	{
		"name":"Digital and Brand marketing",
		"content":"Showing product to world",
		"images":s1
	}
	
	,
	{
		"name":"Video & Animaiton",
		"content":"Visualize your Dream",
		"images":video
	}
	
	

];


export default ServiceData;

